/**
 * El teléfono de soporte, en un solo sitio.
 *
 * Estaba copiado literal en `Settings.tsx` y en `Tutorials.tsx` (el Centro de
 * Ayuda), y en cuatro sitios más de la landing. Cambiar de número obligaba a
 * acordarse de todos; el primero que se olvidara dejaba a alguien escribiendo a
 * un teléfono muerto.
 */
export const SUPPORT_WHATSAPP_NUMBER = "34638684896";

export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;

/**
 * Enlace a WhatsApp con un mensaje ya escrito. Sirve para que quien recibe la
 * consulta sepa de dónde sale sin tener que preguntarlo.
 */
export function supportWhatsAppUrl(message?: string): string {
  if (!message) return SUPPORT_WHATSAPP_URL;
  return `${SUPPORT_WHATSAPP_URL}?text=${encodeURIComponent(message)}`;
}
